<!--  -->
<template>
  <div class="container">
    <div>
      <p class="icon-jujue closeBtn" @click="routerBack"></p>
    </div>
     <div class="searchBox">
      <div style="margin-bottom: 10px" v-if="isCanAudit">
        <!-- <el-button size="mini" class="btn" type="primary" @click="saveData">保存</el-button> -->
        <!-- sup并且是6显示 -->
        <el-button :disabled="isUpload?false:true" size="mini" class="btn" type="primary" v-if="(headerData.status==5||headerData.status==6)&&identity=='SUP'" @click="submitData">提交</el-button>
        <el-button size="mini" class="btn" type="primary" v-if="headerData.status==6&&(statusView=='C'||statusView=='OC')" @click="rectifyData">整改完成</el-button>
        <!-- cqs并且是7显示 -->
      </div>

      <el-card class="box-card">
        <table class="table-d">
            <tr>
                <td>评价期</td>
                <td>{{headerData.appraisePeriod}}</td>
                <td>Facility 编号</td>
                <td>{{headerData.facilityCode}}</td>
                <td>Facility 名称</td>
                <td>{{headerData.facilityName}}</td>
                <td>状态</td>
                <td>{{headerData.statusView}}</td>
            </tr>
            <tr>
                <td>自评截止日期</td>
                <td>{{headerData.closingDate}}</td>
                <td>整改截止日期</td>
                <td>{{headerData.rejectExpireDate}}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </table>
      </el-card>
    </div>


      <el-row  style="margin-top:10px;height:50px;" >
        <el-col :span="3" style="height:100%;display: flex;justify-content: center;align-items: center;color:#EBB563;background:#FCFCFC;">
            附件
        </el-col>
        <el-col :span="12" style="height:100%;display: flex;align-items: center;">
          <div v-if="isCanAudit">
            <el-button v-if="(headerData.status==5||headerData.status==6)&&identity=='SUP'||headerData.status==6&&(statusView=='C'||statusView=='OC')" size="small" type="primary" @click="openFile">
                {{$t('common.selectFile')}}
            </el-button>
          </div>
          
          <!-- <el-upload style="float:left" ref="upload" action="upload" :http-request="uploadConfirm" :show-file-list="false" multiple name="file">
            <el-button slot="trigger" size="small" type="primary">
              {{$t('common.selectFile')}}
            </el-button>
          </el-upload> -->

        </el-col>
      </el-row>
      <ux-grid class="fileTable" ref="plxTable" :data="fileTable" @selection-change="selectionChange" max-height="500" show-overflow="ellipsis" highlight-current-row>
        <ux-table-column align="center" title="附件名称"   field="documentName">
          <template slot-scope="scope">
            <el-button @click="onDownload(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column title="附件描述" align="center" field="docComments">
          <template  slot-scope="scope">
              <el-tooltip  class="item" effect="dark" :content="scope.row.docComments" placement="top-start">
                  <span style="display: inline-block;maxHeight: 80px;padding:10px 0px;box-sizing: border-box;">{{scope.row.docComments}}</span>
              </el-tooltip>
          </template>
        </ux-table-column>
        <ux-table-column title="上传人" align="center" field="userName"></ux-table-column>
        <ux-table-column title="上传时间" align="center" field="createDate"></ux-table-column>
        <ux-table-column title="" align="center" field="updateDate" v-if="(headerData.status==5||headerData.status==6)&&identity=='SUP'||headerData.status==6&&(statusView=='C'||statusView=='OC')">
            <template v-slot="scope">
                <i class="el-icon-delete" style="color: red;" @click="delFile(scope.row)"></i>
            </template>
        </ux-table-column>
      </ux-grid>

      <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <uploadFile v-if="dialogVisible" @close="handleClose" :headerData="headerData" :tsReckindId="tsReckindId"></uploadFile>
      </el-dialog>



  </div>
</template>

<script>
import { fileService } from "@/api/common/file-utils"
import ratingTask from "@/api/AAA/ratingTask.js";
import uploadFile from '@/components/page/QSPI/AAA/dialog/uploadFile'


export default {
  data () {
    return {
        isUpload:false,
        tsReckindId:"",
        dialogVisible:false,
        userID:localStorage.getItem("ms_userId"),
        headerData:{},
        fileTable:[],
        identity:localStorage.getItem('ms_emplFlag'),
        isCanAudit:JSON.parse(sessionStorage.getItem("taskDetail")).isCanAudit,
        rulesList:localStorage.getItem('ms_roles'),
        statusView:"",

    };
  },
  created(){
    this.getDetail()
    let permission = JSON.parse(localStorage.getItem("ms_Permission"));
    if (this.identity=='SUP') {   //判断是供应商
      this.statusView = 'S';
    }else {
      if(this.rulesList.indexOf('QSPI_AAA_CQS')!=-1&&this.rulesList.indexOf('QSPI_AAA_OWNER')!=-1){
        this.statusView = 'OC';
      }else{
        for (let i = 0, len = permission.length; i < len; i++) {
          if (permission[i] == 'QSPI_AAA_OWNER') {
            this.statusView = 'O';
            return
          }else{
            this.statusView = 'C';
          }
        }
      }
    }
    console.log('statusViewstatusView',this.statusView)
  },
  components: {uploadFile},

  computed: {},

  methods: {
    openFile(){
      this.tsReckindId='SUPPLIER_RECTIFY'
      this.dialogVisible=true
    },
    handleClose(){
       this.dialogVisible=false
       this.getFileList()
    },
    getDetail(){
      ratingTask.appraiseDetail(this.$route.query.id).then((res)=>{
        this.headerData=res.data
        this.getFileList();
      })
    },
    submitData(){
      ratingTask.supRectify(this.headerData.ttQspiAaaScoreId).then((res)=>{
        if(res.code==200){
          this.$message.success('提交成功')
          this.$router.back();
        }else{
          this.$message.error(res.msg)
        }
      })
    },
    rectifyData(){
      if(!this.isCanAudit){
        this.$message.error("您没有权限操作数据")
      }else{
        ratingTask.submitRectify(this.headerData.ttQspiAaaScoreId).then((res)=>{
          if(res.code==200){
            this.$message.success('提交成功')
            this.$router.back();
          }else{
            this.$message.error(res.msg)
          }
        })
      }
    },
    //文件上传
      uploadConfirm: function (item) {
        let _this = this;
        let formData = new FormData();
        formData.append("file", item.file);
        fileService.fileUpload(formData).then((res) => {
          let attachment = {};
          attachment.documents = res.data;
          attachment.seq = '1';
          attachment.tsRecId =this.headerData.ttQspiAaaScoreId;
          attachment.tsReckindId = 'SUPPLIER_RECTIFY';
          // comments
          fileService.saveFile(attachment).then((saveRes) => {
            if(saveRes.code==200){
              this.$message.success('保存成功')
              this.getFileList()
            }else{
              this.$message.error(res.msg)
            }
          })
          
        }).catch((error) => {
          //文件上传失败
          Message({ message: this.$t('common.fileUploadFailed'), type: "error" });
        });
      },
      onDownload(row){
        fileService.downloadFile(row).then((res) => { })
      },
      getFileList() {
        let attachment = {};
        attachment.tsReckindId = "SUPPLIER_RECTIFY";
        attachment.tsRecId = this.headerData.ttQspiAaaScoreId;
        fileService.getFileList(attachment).then(res => {
          this.fileTable = res;
          this.isUpload=res.some((v)=>{
            return v.tsReckindId=='SUPPLIER_RECTIFY'
          })
        });
      },
      delFile(row){
        if(row.createBy!=this.userID){
          this.$message.error('只能上传人操作附件')
        }else{
          fileService.deleteFile(row.tmDocumentId).then(res => {
            if(res.code==200){
              this.$message.success('删除成功')
              this.getFileList()
            }else{
              this.$message.error(res.msg)
            }
          });
        }
      },
      routerBack() {
        this.$router.back();
      },
  }
}

</script>
<style  scoped>
/deep/ .fileTable .el-table__row td .cell{
  max-height: 50px;
}
/deep/ .elx-table .elx-body--column.col--ellipsis>.elx-cell{
    max-height: none;
}
</style>